import React from 'react';
import { LayoutDashboard, Folder, Handshake, FilesIcon, Building2, Settings, ChartNoAxesCombined, Send, CircleCheckBig, NotepadText, Palette, Package, Users, BarChart3, Hammer, FileSignature, Inbox, Gift, Award, Landmark, Wallet, Ticket } from 'lucide-react';
import { FEATURE_PERMISSIONS } from '../constants/featurePermissions';
import { SUB_FEATURES } from '../constants/subscriptionFeatures';

export const menu = [
  {
    id: 1,
    displayName: 'Dashboard',
    path: '/dashboard',
    icon: <LayoutDashboard size={16} />,
    roles: ['ADMIN', 'AGENT', 'SALES', "DEVELOPER", "ZUMALE_USER"],
  },
  {
    id: 2,
    displayName: 'Projects',
    path: '/projects',
    icon: <Folder size={16} />,
    roles: ['ADMIN', 'AGENT', 'SALES', "DEVELOPER"],
    hasSubmenu: false,
    submenu: [],
    requiresAnyPermission: FEATURE_PERMISSIONS.PROJECTS,
  },
  {
    id: 3,
    displayName: 'Properties',
    path: '/properties',
    icon: <Building2 size={16} />,
    roles: ['ADMIN', 'SALES', "DEVELOPER","PRESALES","PRESALES_SALES"],
    requiresAnyPermission: FEATURE_PERMISSIONS.PROPERTIES,
  },
  {
    id: 4,
    displayName: 'Channel Partners',
    path: '/agents',
    icon: <Handshake size={16} />,
    roles: ['ADMIN', 'SALES', "DEVELOPER","PRESALES_SALES"],
    requiresAnyPermission: FEATURE_PERMISSIONS.CHANNEL_PARTNERS_PAGE,
    requiresFeature: SUB_FEATURES.CRM,
  },
  {
    id: 5,
    displayName: 'Sales Agent',
    path: '/communications',
    icon: <Send size={16} />,
    roles: ['ADMIN', "DEVELOPER","PRESALES","PRESALES_SALES"],
    hasSubmenu: false,
    submenu: [],
    requiresAnyPermission: FEATURE_PERMISSIONS.VIRTUAL_AGENTS,
    requiresFeature: SUB_FEATURES.CRM,
  },
  {
    id: 6,
    displayName: 'Sales',
    path: '/customers',
    icon: <ChartNoAxesCombined size={16} />,
    roles: ['ADMIN', 'SALES', 'AGENT', "DEVELOPER","PRESALES","PRESALES_SALES"],
    requiresAnyPermission: FEATURE_PERMISSIONS.SALES_PAGE,
  },
  {
    id: 38,
    displayName: 'Referral Commissions',
    path: '/referral-commissions',
    icon: <Wallet size={16} />,
    roles: ['AGENT'],
  },
  // {
  //   id: 7,
  //   displayName: 'Sales',
  //   path: '/sales',
  //   icon: <ChartNoAxesCombined size={16} />,
  //   roles: ['ADMIN', "DEVELOPER", "SALES"],
  // },
  {
    id: 8,
    displayName: 'Reports',
    path: '/reports',
    icon: <NotepadText  size={16} />,
    roles: ['ADMIN', "DEVELOPER", 'SALES'],
    hasSubmenu: false,
    submenu: [],
    requiresAnyPermission: FEATURE_PERMISSIONS.REPORTS,
  },

  {
    id: 12,
    displayName: 'Requests',
    path: '/approvals',
    icon: <CircleCheckBig size={16} />,
    roles: ['ADMIN', "DEVELOPER", 'SALES',],
    requiresAnyPermission: FEATURE_PERMISSIONS.APPROVALS,
  },
  {
    id: 24,
    displayName: 'Customers',
    path: '/zumale_user-dashboard',
    icon: <Users size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 28,
    displayName: 'Reports',
    path: '/zumale-admin/reports',
    icon: <BarChart3 size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 34,
    displayName: 'Projects',
    path: '/zumale-admin/projects',
    icon: <Building2 size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 37,
    displayName: 'Internal Owners',
    path: '/zumale-admin/internal-owners',
    icon: <Landmark size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 29,
    displayName: 'Interior Executions',
    path: '/zumale-admin/interior-executions',
    icon: <Hammer size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 26,
    displayName: 'Material & Vendors',
    path: '/zumale-admin/material-vendors',
    icon: <Package size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    // Replaces the old "Subscription Approvals" entry — phase-application approvals now
    // live inside the full Interior Designers admin section (designers + applications + receipts).
    id: 23,
    displayName: 'Interior Designers',
    path: '/zumale-admin/interior-designers',
    icon: <Palette size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 35,
    displayName: 'Referral Partners',
    path: '/zumale-admin/referral-vendors',
    icon: <Gift size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 38,
    displayName: 'Referrals',
    path: '/zumale-admin/referrals',
    icon: <Handshake size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 36,
    displayName: 'Referral Rewards',
    path: '/zumale-admin/referral-rewards',
    icon: <Award size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 37,
    displayName: 'Referral Redemptions',
    path: '/zumale-admin/referral-redemptions',
    icon: <Ticket size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 30,
    displayName: 'Agreements',
    path: '/zumale-admin/agreements',
    icon: <FileSignature size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 31,
    displayName: 'Requests',
    path: '/zumale-admin/requests',
    icon: <Inbox size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 32,
    displayName: 'Team',
    path: '/zumale-admin/team',
    icon: <Users size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 25,
    displayName: 'Settings',
    path: '/zumale-admin/settings',
    icon: <Settings size={16} />,
    roles: ['ZUMALE_USER'],
  },
  {
    id: 13,
    displayName: 'My Visits',
    path: '/user-dashboard', //Changed the path to user dashboard
    icon: <FilesIcon size={16} />,
    roles: ['USER'],
  },
  {
    id: 15,
    displayName: 'Settings',
    path: '/profile#onboarding',
    icon: <Settings size={16} />,
    roles: ['ADMIN', "DEVELOPER", 'SALES', 'AGENT'],
    // Onboarding sub-page itself is restricted to Developer Admin (developerAdminOnly:true).
    // The Settings menu entry stays visible for everyone with general profile access; the
    // onboarding tab inside is hidden by Profile.jsx via usePermission.isDeveloperAdmin().
  },
  // "Manage Roles" sidebar entry removed — Role Based Access now lives under
  // Settings → Profile (see Profile.jsx menuItems).
  {
    id: 17,
    displayName: 'Leads',
    path: '/interior-designer/leads',
    icon: <Handshake size={16} />,
    roles: ['INTERIOR_DESIGNER'],
  },
  {
    id: 16,
    displayName: 'Phases',
    path: '/interior-designer/phases',
    icon: <Building2 size={16} />,
    roles: ['INTERIOR_DESIGNER'],
  },
  {
    id: 21,
    displayName: 'Buyers',
    path: '/bv-user/buyers',
    icon: <Handshake size={16} />,
    roles: ['BV_USER'],
  },
  {
    id: 20,
    displayName: 'Phases',
    path: '/bv-user/phases',
    icon: <Building2 size={16} />,
    roles: ['BV_USER'],
  },
  {
    id: 24,
    displayName: 'Interior Execution',
    path: '/interior-execution',
    icon: <Package size={16} />,
    roles: ['BV_USER'],
  },
  // BV Settings comes last so the BV menu reads Buyers → Phases → Interior Execution → Settings.
  // Kept as its own entry (instead of adding BV_USER to id:15) so positioning
  // for ADMIN/DEVELOPER/SALES/AGENT — who have Settings nearer the top —
  // isn't disturbed.
  {
    id: 23,
    displayName: 'Settings',
    path: '/profile#onboarding',
    icon: <Settings size={16} />,
    roles: ['BV_USER'],
  },
  {
    id: 18,
    displayName: 'My Designs',
    path: '/interior-designer/designs',
    icon: <Palette size={16} />,
    roles: ['INTERIOR_DESIGNER'],
  },
  {
    id: 19,
    displayName: 'Settings',
    path: '/interior-designer/settings',
    icon: <Settings size={16} />,
    roles: ['INTERIOR_DESIGNER'],
  },

  // {
  //   id: 10,
  //   displayName: 'Agreement',
  //   path: '/user-agreements',
  //   icon: <FilesIcon size={16} />,
  //   roles: ['USER'],
  // },

  // Work marketplace — Architect (Party A)
  {
    id: 60,
    displayName: 'My Projects',
    path: '/architect/dashboard',
    icon: <Building2 size={16} />,
    roles: ['ARCHITECT'],
  },
  {
    id: 61,
    displayName: 'Wallet',
    path: '/architect/wallet',
    icon: <Wallet size={16} />,
    roles: ['ARCHITECT'],
  },
  {
    id: 62,
    displayName: 'Profile',
    path: '/architect/profile',
    icon: <Settings size={16} />,
    roles: ['ARCHITECT'],
  },

  // Work marketplace — Freelancer (Party B)
  {
    id: 63,
    displayName: 'My Work',
    path: '/freelancer/dashboard',
    icon: <Inbox size={16} />,
    roles: ['FREELANCER'],
  },
  {
    id: 64,
    displayName: 'My Skills',
    path: '/freelancer/skills',
    icon: <Award size={16} />,
    roles: ['FREELANCER'],
  },
  {
    id: 65,
    displayName: 'Profile',
    path: '/freelancer/profile',
    icon: <Settings size={16} />,
    roles: ['FREELANCER'],
  },

  // Work marketplace — Zumale admin
  {
    id: 66,
    displayName: 'Work Marketplace',
    path: '/zumale-admin/marketplace',
    icon: <Package size={16} />,
    roles: ['ZUMALE_USER'],
  },
];

// Maps each legacy role string (still declared in each menu item's `roles:` array)
// onto the new PersonaType values, so a single persona can match multiple legacy entries.
const PERSONA_TO_LEGACY_ROLES = {
  STAFF: ['ADMIN', 'SALES', 'PRESALES', 'PRESALES_SALES'],
  DEVELOPER_ADMIN: ['ADMIN', 'DEVELOPER'],
  CHANNEL_PARTNER: ['AGENT'],
  PROPERTY_BUYER: ['USER'],
  INTERIOR_DESIGNER: ['INTERIOR_DESIGNER'],
  BV_ASSOCIATE: ['BV_USER'],
  ZUMALE_USER: ['ZUMALE_USER'],
  ARCHITECT: ['ARCHITECT'],
  FREELANCER: ['FREELANCER'],
};

// Personas that participate in RBAC permission scoping. For everyone else
// (CHANNEL_PARTNER, PROPERTY_BUYER, INTERIOR_DESIGNER, ZUMALE_USER), menu
// visibility is persona-only — they don't use the per-project permission map.
const RBAC_SCOPED_PERSONAS = new Set(['STAFF', 'BV_ASSOCIATE']);

// Helper: does the user satisfy this item's permission requirements?
//   - DEVELOPER_ADMIN (and any other persona where isDeveloperAdmin=true) → always yes
//   - Other non-RBAC personas → always yes (handled purely by `roles:` list)
//   - STAFF / BV_ASSOCIATE → must have one of the codes on at least one project
const userHasAnyPermission = (permissionCtx, codes, persona) => {
  if (!codes || codes.length === 0) return true;
  if (!permissionCtx) return true; // pre-hydration safety
  if (permissionCtx.isDeveloperAdmin) return true;
  if (!RBAC_SCOPED_PERSONAS.has(persona)) return true;
  const byProject = permissionCtx.byProject || {};
  return Object.values(byProject).some((perms) =>
    Array.isArray(perms) && perms.some((p) => codes.includes(p))
  );
};

// Read a dotted-path key from the subscription feature JSON. Returns false
// when any segment is missing — fail-closed (mirrors the BE helper).
const readDottedPath = (obj, path) => {
  if (!obj || !path) return undefined;
  let cursor = obj;
  for (const segment of path.split('.')) {
    if (cursor == null || typeof cursor !== 'object') return undefined;
    cursor = cursor[segment];
  }
  return cursor;
};

// Internal personas administer all tenants — their menu is never plan-gated.
const PERSONAS_BYPASS_PLAN = new Set(['BV_ASSOCIATE', 'ZUMALE_USER']);

const itemAllowedByPlan = (item, persona, subscriptionFeatures) => {
  if (!item.requiresFeature) return true;
  if (PERSONAS_BYPASS_PLAN.has(persona)) return true;
  return readDottedPath(subscriptionFeatures, item.requiresFeature) === true;
};

// `persona` is the PersonaType string from userInfo.persona.
// `permissionCtx` is userInfo.permissions (optional).
// `subscriptionFeatures` is userInfo.loginIdentifierDetails.subscription
//   .subscriptionType.feature (optional). When passed, items requiring a
//   feature the tenant does not have are returned with `disabled: true`
//   instead of filtered out — the sidebar renders them as upsell affordances
//   via DisabledWithTooltip.
export const getMenu = (persona, permissionCtx = null, subscriptionFeatures = null) => {
  if (!persona) return [];
  const legacyRoles = PERSONA_TO_LEGACY_ROLES[persona] || [];

  return menu
    // RBAC filtering runs FIRST and is unchanged. Items the persona has no
    // role for, or no permission for, are removed entirely. Subscription
    // gating below only flips items that already pass RBAC to `disabled`.
    .filter((item) => item.roles.some((role) => legacyRoles.includes(role)))
    .filter((item) => userHasAnyPermission(permissionCtx, item.requiresAnyPermission, persona))
    .map((item) => {
      if (item.displayName === 'Dashboard') {
        const dashboardPathByPersona = {
          DEVELOPER_ADMIN: '/admin-dashboard',
          STAFF: '/admin-dashboard',
          CHANNEL_PARTNER: '/agent-dashboard',
          PROPERTY_BUYER: '/user-dashboard',
          INTERIOR_DESIGNER: '/interior-designer-dashboard',
          BV_ASSOCIATE: '/bv-user-dashboard',
          ZUMALE_USER: '/zumale-admin-dashboard',
        };
        item = { ...item, path: dashboardPathByPersona[persona] || '/dashboard' };
      }

      const planAllowed = itemAllowedByPlan(item, persona, subscriptionFeatures);

      return {
        ...item,
        disabled: !planAllowed,
        disabledReason: !planAllowed ? 'Available on BuildVizer Unified' : null,
        submenu: item.hasSubmenu
          ? item.submenu
              .filter((subItem) => subItem.roles.some((role) => legacyRoles.includes(role)))
              .filter((subItem) =>
                userHasAnyPermission(permissionCtx, subItem.requiresAnyPermission, persona)
              )
              .map((subItem) => {
                const subPlanAllowed = itemAllowedByPlan(subItem, persona, subscriptionFeatures);
                return {
                  ...subItem,
                  path: subItem.path,
                  disabled: !subPlanAllowed,
                  disabledReason: !subPlanAllowed ? 'Available on BuildVizer Unified' : null,
                };
              })
          : undefined,
      };
    });
};


export default menu;